const win = typeof window === 'object' ? window : {};
const storageSession = win.sessionStorage;
const storageLocal = win.localStorage;

const storageSessRmItem = ( key, ss = storageSession ) => ss.removeItem( key );
const storageSessGetItem = ( key, ss = storageSession ) => ss.getItem( key );
const storageSessSetItem = ( key, val, ss = storageSession ) => ss.setItem( key, val );
const storageLocalRmItem = ( key, ls = storageLocal ) => ls.removeItem( key );
const storageLocalGetItem = ( key, ls = storageLocal ) => ls.getItem( key );
const storageLocalSetItem = ( key, val, ls = storageLocal ) => ls.setItem( key, val );

export {
  storageLocalRmItem,
  storageLocalGetItem,
  storageLocalSetItem,

  storageSessRmItem,
  storageSessGetItem,
  storageSessSetItem
}
